import classNames from 'classnames';
import React, { forwardRef } from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { ExtensionType } from '@/store/models/extensions-model';
import { useExtensionHelper } from '../../use-extension-helper';
import styles from './extension-container.module.less';

const ExtensionContainer = forwardRef<HTMLDivElement, { useVisibility: boolean }>((useVisibility, ref) => {
    const handleClose = () => {
        setDisplay(false);
    };

    const { display, setDisplay, style, type = ExtensionType.popUp } = useExtensionHelper();

    // console.log({ display, useVisibility, style, type });

    if (type === ExtensionType.popUp) {
        return (
            <div
                id="extension-container"
                ref={ref}
                className={classNames(styles.extensionContainerWrap, styles[type])}
                style={{
                    display: !useVisibility && !display ? 'none' : '',
                    visibility: useVisibility && !display ? 'hidden' : 'visible',
                }}
            >
                <div className={classNames(styles.extensionContainer, 'extensionContainer')} style={style}>
                    <div className={classNames(styles.iframeContainer, 'iframeContainer')}></div>
                    <span className={styles.closeIcon} onClick={handleClose}>
                        <IconFont fontSize={18} name="CrossBlack" />
                    </span>
                </div>
            </div>
        );
    }

    return null;
});

ExtensionContainer.displayName = 'ExtensionContainer';

export default React.memo(ExtensionContainer);
